import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #c5eaff;
  flex: 1;
  /*height: calc(100vh - (98px + 121.25px));
iframe {
  height: 65vh;
}


  @media (max-width: 768px) {
    height: calc(100vh - (98px + 157.25px));
    iframe {
      height: 55vh;
    }
    @media (max-width: 320px) {
      height: calc(100vh - (98px + 329.44px));
      iframe {
        height: 42vh;
      }*/
`;
